export default __webpack_public_path__ + "static/all-in-one-be7d2a1d10c9dbcf74651bb93b381906.svg";